import { render, staticRenderFns } from "./TransparentColorPicker.vue?vue&type=template&id=74f38812&"
import script from "./TransparentColorPicker.vue?vue&type=script&lang=ts&"
export * from "./TransparentColorPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports